<template>
  <!-- 导出运行简报 -->
  <div class="analysisReport">
    <!-- <el-button type="primary" class="export" @click="downloadPage('pdfPrint',header.zykNum,header.zykName)">导出</el-button> -->
    <!-- <el-button class="export" type="primary" size="small" @click="toImage" v-if="false">生成PDF</el-button> -->
    <div style="margin-top: 80px" class="analysisReport_box" id="pdfPrint">
      <!-- 第一页 -->
      <div style="height: 2740px">
        <div class="header_titles">
          <h1 style="margin-bottom: 20px">
            <span v-show="false">这是completeNum的值：{{ completeNum }}</span>
            <input id="completeNum" v-show="false" v-model="completeNum" />
            职业教育“{{ header.zykName }}”专业教学资源库({{ header.zykNum }})
          </h1>
          <h1 style="margin-top: 3px">建设与应用分析简报</h1>

          <div class="number_time">
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-top: 50px;
              "
            >
              <div style="flex: 0.6; text-align: left">
                <span style="width: 14%; font-size: 1.5925rem"> 主持单位：</span>
                <span style="width: 86%; color: #707f9d; font-size: 1.5925rem">{{
                  yearMonthText
                }}</span>
              </div>
              <span style="color: #707f9d; flex: 0.4; font-size: 1.5925rem; text-align: right"
                >数据分析时间：2020-01-01 至 {{ timeDate }}</span
              >
            </div>
            <p></p>
            <p></p>
          </div>
        </div>

        <div class="division">
          <span>建设与更新情况</span>
        </div>

        <div class="chart_box">
          <h4>一、用户建设与更新情况</h4>
          <h4 style="margin-left: 1.5em; margin-top: 20px">1.1 用户总览</h4>
          <p style="margin-top: 40px">
            当前该资源库的用户数(教师和学生)为{{ dataHandler(ziyuan.total) }}人，其中学生{{
              dataHandler(ziyuan.student)
            }}人，占{{ ziyuan.studentList }}%；教师{{ dataHandler(ziyuan.teacher) }}人，占{{
              ziyuan.teacherList
            }}%(如图1 所示)。这些用户来自全国{{ ziyuan.totalProvince }}个省级行政区，{{
              ziyuan.totalSchool
            }}所学校。{{ resourceLibrary.FristYear
            }}{{ dataHandler(resourceLibrary.FristNum) }}人，{{ resourceLibrary.SecondYear
            }}{{ dataHandler(resourceLibrary.SecondNum) }}人，{{ resourceLibrary.ThirdYear
            }}{{ dataHandler(resourceLibrary.ThirdNum) }}人，{{ resourceLibrary.FourthYear
            }}{{ dataHandler(resourceLibrary.FourthNum) }}人。共删除用户{{
              resourceLibrary.delNum
            }}人。
          </p>

          <div class="standards_content echartsHeight" style="margin-top: 20px">
            <circularChart
              :refId="'typeDistributionChart'"
              :isShowTextColor="true"
              :datas="ziyuan.dataList"
              :colorName="1"
              :innerText="'数量'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :circleSize="80"
              :legendListFontSize="40"
              :circleFontSize="35"
            ></circularChart>
          </div>
          <div class="chart_name">图1 资源库注册用户类型分布总体情况</div>
        </div>
        <!-- 资源库用户注册时间分布 -->
        <div class="chart_box">
          <h4 style="margin-left: 1.5em">1.2 资源库用户注册时间分布</h4>
          <!-- 柱图 -->
          <div class="chart_box">
            <div class="standards_content echartsHeight" style="height: 900px">
              <vcolumnarChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                id="map"
                :refId="'participatingChart'"
                :datas="register.dataList"
                :legendList="register.legendList"
                :colorList="register.colorList"
                :transverseData="register.transverseData"
                :colorName="1"
                :innerText="'单位：人'"
                :titleLeft="'32%'"
                :legendBackgroundColor="true"
                :circleSize="100"
              ></vcolumnarChart>
            </div>
          </div>
        </div>
      </div>

      <!-- 第二页 -->
      <div
        style="height: 2740px; display: flex; flex-direction: column; justify-content: space-around"
      >
        <!-- 折线图 -->
        <div class="chart_box" style="margin-top: 50px">
          <div class="standards_content echartsHeight" style="height: 1000px">
            <discountChart
              :isExportTextColor="true"
              :isShowTextColor="true"
              :refId="'typeDistributionChart'"
              :datas="UserCreateList.dataList"
              :legendList="UserCreateList.legendList"
              :transverseData="UserCreateList.transverseData"
              :colorList="UserCreateList.colorList"
              :colorName="2"
              :innerText="'单位:人'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :circleSize="80"
            ></discountChart>
          </div>
          <div class="chart_name">图2 资源库用户注册时间分布情况（分别按年、月统计）</div>
        </div>

        <div class="chart_box" style="margin-bottom: 220px">
          <h4 style="margin-left: 1.5em">1.3 参建单位注册用户排名</h4>
          <p style="margin-top: 40px">
            当前,该资源库参建单位注册用户(教师和学生)情况排名如图3所示。
          </p>
          <div class="standards_content echartsHeight" style="height: 1000px">
            <tcolumnarChart
              :isShowTextColor="true"
              :isExportTextColor="true"
              :refId="'typeDistributionChart'"
              :datas="projectTop.dataList"
              :transverseData="projectTop.transverseData"
              :colorList="projectTop.colorList"
              :colorName="2"
              :innerText="'单位：人'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :circleSize="100"
            >
            </tcolumnarChart>
          </div>
          <div class="chart_name">
            图3 当前资源库参建单位注册用户（教师和学生）情况排名（前十名）
          </div>
        </div>
      </div>

      <!-- 第三页 -->
      <div
        style="height: 2740px; display: flex; flex-direction: column; justify-content: space-around"
      >
        <div class="chart_box" style="margin-top: 100px">
          <h4>二、素材资源建设与更新情况</h4>
          <h4 style="margin-left: 1.5em; margin-top: 20px">2.1 素材资源总览</h4>
          <p style="margin-top: 40px">
            素材资源总数为{{ sucaiziyuanAll.total }}条，其中文本类和图形/图像类为{{
              dataHandler(sucaiziyuanAll.textVo.sumValue)
            }}条，占比{{ sucaiziyuanAll.WenbenBai }}，文本型演示稿类(包含PPT、
            网页课件、富媒体等)为{{ dataHandler(sucaiziyuanAll.textPPTVo.sumValue) }}条，占比{{
              sucaiziyuanAll.web
            }}(如图4所示)。 {{ update.FristYear.yearUpdate.replace("比", "相对")
            }}{{ dataHandler(update.FristYear.num) }}，
            {{ update.SecondYear.yearUpdate.replace("比", "相对")
            }}{{ dataHandler(update.SecondYear.num) }}，
            {{ update.ThirdYear.yearUpdate.replace("比", "相对")
            }}{{ dataHandler(update.ThirdYear.num) }}， 共删除素材资源{{
              dataHandler(sucaiyearAdd.delNum)
            }}条。
          </p>
          <div class="standards_content echartsHeight" style="margin-top: 50px">
            <circularChart
              isShowTextColor="true"
              style="margin-left: -120px; width: 120%"
              :refId="'typeDistributionChart'"
              :datas="sucaiziyuanAll.dataList"
              :colorName="1"
              :innerText="'数量'"
              :titleLeft="'22%'"
              :legendBackgroundColor="true"
              :legendLeft="'40%'"
              :seriesRight="'55%'"
              :circleSize="80"
              :legendListFontSize="35"
              :circleFontSize="35"
            ></circularChart>
          </div>
          <div class="chart_name" style="margin-top: 50px">图4 资源库素材资源类型分布</div>
        </div>

        <div class="chart_box" style="margin-bottom: 190px">
          <h4 style="margin-left: 1.5em">2.2 素材资源创建时间分布</h4>

          <div class="standards_content echartsHeight" style="height: 1100px">
            <vcolumnarChart
              :isExportTextColor="true"
              :isShowTextColor="true"
              :refId="'participatingChart'"
              :datas="sucaiziyuanCreated.dataList"
              :transverseData="sucaiziyuanCreated.transverseData"
              :colorList="sucaiziyuanCreated.colorList"
              :legendList="sucaiziyuanCreated.legendList"
              :colorName="2"
              :innerText="'单位：条'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :circleSize="80"
            ></vcolumnarChart>
          </div>

          <!-- <div class="standards_content echartsHeight" style="height: 430px;">
            <discountChart :isExportTextColor="true" :isShowTextColor="true" :refId="'participatingChart'" :datas='SucaiziyuanCreated.dataList' :transverseData="SucaiziyuanCreated.transverseData" :colorList="SucaiziyuanCreated.colorList" :legendList="SucaiziyuanCreated.legendList" :colorName='2' :innerText="'单位：条'" :titleLeft="'32%'" :legendBackgroundColor="true" :circleSize="80"></discountChart>
          </div>
          <div class="chart_name">图5 素材资源创建时间分布（分别按年、月统计）</div> -->
        </div>
      </div>

      <!-- 第四页 -->
      <div
        style="height: 2740px; display: flex; flex-direction: column; justify-content: space-around"
      >
        <div class="chart_box" style="margin-top: 40px">
          <div class="standards_content echartsHeight" style="height: 1000px">
            <discountChart
              :isExportTextColor="true"
              :isShowTextColor="true"
              :refId="'participatingChart'"
              :datas="SucaiziyuanCreated.dataList"
              :transverseData="SucaiziyuanCreated.transverseData"
              :colorList="SucaiziyuanCreated.colorList"
              :legendList="SucaiziyuanCreated.legendList"
              :colorName="2"
              :innerText="'单位：条'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :circleSize="80"
            ></discountChart>
          </div>
          <div class="chart_name">图5 素材资源创建时间分布（分别按年、月统计）</div>
        </div>

        <div class="chart_box" style="margin-bottom: 210px">
          <h4>三、课程建设与更新情况</h4>
          <h4 style="margin-left: 1.5em; margin-top: 20px">3.1 课程总览</h4>
          <p style="margin-top: 40px">
            该资源库建有标准化课程{{ kechengAll.count }}门。<br />
            （注1：标准化课程指资源库建设团队按照《指南》要求建设和提供的，涵盖课程基本知识点和技能点，能够适应全国同类和相近专业在线教学基本需要的结构化课程。标准化课程的正确性、逻辑性、权威性是由资源库建设团队保证。注2：如标准化课程显示为0，表明该资源库在课程标注上不规范，需要在资源库运行平台中对课程分类重新标注。）
          </p>

          <div class="chart_box">
            <h4 style="margin-left: 1.5em">3.2 课程创建时间分布</h4>
            <!-- 人数饼状图 -->
            <div class="standards_content echartsHeight" style="height: 600px">
              <vcolumnarChart
                isShowTextColor="true"
                isExportTextColor="true"
                :refId="'resourceLibraryChart'"
                :datas="kechengcreateds.dataList"
                :transverseData="kechengcreateds.transverseData"
                :colorList="projectTop.colorList"
                :colorName="1"
                :innerText="'单位:门'"
                :titleLeft="'32%'"
                :legendBackgroundColor="true"
                :circleSize="80"
              ></vcolumnarChart>
            </div>
            <div class="chart_name" style="margin-top: -50px">图6 课程创建时间分布</div>
          </div>
        </div>
      </div>

      <!-- 第五页 -->
      <!-- <div style=" height: 2700px">

      </div> -->

      <!-- 第六页 -->
      <div
        style="height: 2740px; display: flex; flex-direction: column; justify-content: space-around"
      >
        <!-- <div class="division" style="margin-bottom:40px;">
          <span>应用情况</span>
        </div>
        <hr> -->

        <div class="chart_box" style="margin-top: 50px">
          <div class="division">
            <span>应用情况</span>
          </div>
          <hr />
          <h4 style="margin-top: 50px">四、用户行为情况</h4>
          <h4 style="margin-left: 1.5em; margin-top: 50px">4.1 用户行为类型分布</h4>
          <p style="margin-top: 20px">
            该资源库用户行为活动总量为{{ dataHandler(useractiveAllList.total) }}次，参与用户数{{
              dataHandler(userTotal.actionUser)
            }}人，素材资源使用总次数{{
              dataHandler(useractiveAllList.sucai)
            }}次，平均每个资源使用次数为{{ dataHandler(useractiveAllList.sucaiAvg) }}次。
            论坛活动模块{{ dataHandler(useractiveAllList.luntan) }}次，作业活动模块{{
              dataHandler(useractiveAllList.zuoye)
            }}次，考试活动模块{{ dataHandler(useractiveAllList.kaoshi) }}次，(如图7所示)。该资源库{{
              timeDate.substring(0, 4)
            }}年用户行为总量为{{ dataHandler(userTotal.total) }}次，学生人均行为次数为{{
              dataHandler(userTotal.studentAvg)
            }}次。
          </p>
          <div class="standards_content echartsHeight" style="margin-top: 50px">
            <circularChart
              :isShowTextColor="true"
              :refId="'typeDistributionChart'"
              :datas="useractiveAllList.dataList"
              :colorName="1"
              :innerText="'单位:次'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :circleSize="80"
              :legendListFontSize="35"
              :circleFontSize="35"
            ></circularChart>
          </div>
          <div class="chart_name" style="margin-top: 50px">图7 资源库用户行为类型分布情况</div>
        </div>

        <div class="chart_box" style="margin-bottom: 210px">
          <!-- <h4>四、用户行为情况</h4>
          <h4 style="margin-left: 1.5em;margin-top: 20px;">4.1 用户行为类型分布</h4>
          <p style="margin-top: 20px;">该资源库用户行为活动总量为{{dataHandler(useractiveAllList.total)}}次，参与用户数{{dataHandler(userTotal.actionUser)}}人，素材资源使用总次数{{dataHandler(useractiveAllList.sucai)}}次，平均每个资源使用次数为{{dataHandler(useractiveAllList.sucaiAvg)}}次。
            论坛活动模块{{dataHandler(useractiveAllList.luntan)}}次，作业活动模块{{dataHandler(useractiveAllList.zuoye)}}次，考试活动模块{{dataHandler(useractiveAllList.kaoshi)}}次，(如图7所示)。该资源库{{timeDate.substr(0,4)}}年用户行为总量为{{dataHandler(userTotal.total)}}次，学生人均行为次数为{{dataHandler(userTotal.studentAvg)}}次。
          </p>
          <div class="standards_content echartsHeight">
            <circularChart :isShowTextColor="true" :refId="'typeDistributionChart'" :datas='useractiveAllList.dataList' :colorName='1' :innerText="'单位:次'" :titleLeft="'32%'" :legendBackgroundColor="true" :circleSize="80" :legendListFontSize="30"></circularChart>
          </div>
          <div class="chart_name">图7 资源库用户行为类型分布情况</div> -->
          <div class="standards_content echartsHeight" style="height: 1000px">
            <discountChart
              :isExportTextColor="true"
              :isShowTextColor="true"
              :refId="'typeDistributionChart'"
              :datas="sss.dataList"
              :colorList="sss.colorList"
              :innerHtml="'单位:次'"
              :transverseData="sss.transverseData"
              :colorName="2"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :circleSize="80"
            ></discountChart>
            <div class="chart_name" style="margin-top: -90px">
              图8 近一年用户行为产生的时间分布情况（按天统计）
            </div>
          </div>
        </div>
      </div>

      <!-- 第七页 -->
      <div
        style="height: 2740px; display: flex; flex-direction: column; justify-content: space-around"
      >
        <div class="chart_box" style="margin-top: 60px">
          <h4 style="margin-left: 1.5em">4.2 近一年不同类型用户行为分布</h4>
          <div class="standards_content echartsHeight" style="margin-top: 50px">
            <circularChart
              :isShowTextColor="true"
              :refId="'typeDistributionChart'"
              :datas="userxingwei.dataList"
              :legendListFontSize="40"
              :circleFontSize="35"
              :colorList="userxingwei.colorList"
              :colorName="1"
              :innerText="'数量'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :circleSize="80"
            ></circularChart>
          </div>
          <div class="chart_name" style="margin-top: 50px">图9 不同类型用户产生的行为分布情况</div>
        </div>
        <div class="chart_box" style="margin-bottom: 180px">
          <h4 style="margin-left: 1.5em; margin-top: 50px">
            4.3 近一年不同类型用户行为时间分布情况
          </h4>
          <div class="standards_content echartsHeight" style="height: 1100px">
            <discountChart
              :isExportTextColor="true"
              :isShowTextColor="true"
              :refId="'typeDistributionChart'"
              :legendList="differentUserTime.legendList"
              :datas="differentUserTime.dataList"
              :transverseData="differentUserTime.transverseData"
              :colorList="differentUserTime.colorList"
              :colorName="2"
              :innerText="'单位:次'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :circleSize="80"
            ></discountChart>
          </div>
          <div class="chart_name">图10 近一年不同类型用户行为时间分布情况</div>
        </div>
      </div>

      <!-- 第八页 -->
      <div
        style="height: 2740px; display: flex; flex-direction: column; justify-content: space-around"
      >
        <div class="chart_box" style="margin-top: 70px">
          <h4 style="margin-left: 1.5em">4.4 教师访问情况排名</h4>
          <div class="standards_content echartsHeight" style="height: 1050px">
            <tcolumnarChart
              isShowTextColor="true"
              isExportTextColor="true"
              :refId="'resourceLibraryChart'"
              :datas="tearchTopList.dataList"
              :colorList="tearchTopList.colorList"
              :transverseData="tearchTopList.transverseData"
              :colorName="1"
              :innerText="'单位：次'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :circleSize="80"
            ></tcolumnarChart>
          </div>
          <div class="chart_name">图11 教师访问量排名（前十名）</div>
        </div>
        <div class="chart_box" style="margin-bottom: 200px">
          <h4 style="margin-left: 1.5em; margin-bottom: 30px">4.5 学生访问情况排名</h4>
          <div class="standards_content echartsHeight" style="height: 1050px">
            <tcolumnarChart
              isShowTextColor="true"
              isExportTextColor="true"
              :refId="'resourceLibraryChart'"
              :datas="studentTopList.dataList"
              :colorList="studentTopList.colorList"
              :transverseData="studentTopList.transverseData"
              :colorName="1"
              :innerText="'单位：次'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :circleSize="80"
            ></tcolumnarChart>
          </div>
          <div class="chart_name">图12 学生访问量排名（前十名）</div>
        </div>
      </div>

      <!-- 第九页 -->
      <div
        style="height: 2740px; display: flex; flex-direction: column; justify-content: space-around"
      >
        <div class="chart_box" style="margin-top: 60px">
          <h4>五、素材资源应用情况</h4>
          <h4 style="margin-left: 1.5em; margin-top: 20px">5.1 近一年素材资源访问情况</h4>
          <div class="standards_content echartsHeight" style="height: 1050px">
            <discountChart
              :isExportTextColor="true"
              :isShowTextColor="true"
              :refId="'resourceLibraryChart'"
              :datas="sucaiziyuanyingyong.dataList"
              :transverseData="sucaiziyuanyingyong.transverseData"
              :legendList="sucaiziyuanyingyong.legendList"
              :colorList="sucaiziyuanyingyong.colorList"
              :colorName="1"
              :innerText="'单位:次'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :circleSize="80"
            ></discountChart>
          </div>
          <div class="chart_name">图13 近一年素材资源访问情况</div>
        </div>
        <div class="chart_box" style="margin-bottom: 200px">
          <h4 style="margin-left: 1.5em">5.2 素材资源访问量排名</h4>
          <!-- 人数饼状图 -->
          <div class="standards_content echartsHeight" style="height: 1000px">
            <tcolumnarChart
              isShowTextColor="true"
              isExportTextColor="true"
              :refId="'resourceLibraryChart'"
              :datas="sucaiziyuanfagnwen.dataList"
              :transverseData="sucaiziyuanfagnwen.transverseData"
              :colorList="sucaiziyuanfagnwen.colorList"
              :colorName="1"
              :innerText="'单位：次'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :circleSize="80"
            ></tcolumnarChart>
          </div>
          <div class="chart_name">图14 素材资源访问量排名（前十名）</div>
        </div>
      </div>

      <!-- 第十页 -->
      <div
        style="height: 2740px; display: flex; flex-direction: column; justify-content: space-around"
      >
        <div class="chart_box" style="margin-top: 50px">
          <h4>六、课程应用情况</h4>
          <h4 style="margin-left: 1.5em">6.1 近一年课程访问情况</h4>
          <div class="standards_content echartsHeight" style="height: 1050px">
            <discountChart
              :isExportTextColor="true"
              :isShowTextColor="true"
              :refId="'resourceLibraryChart'"
              :datas="oneYearkecheng.dataList"
              :transverseData="oneYearkecheng.transverseData"
              :colorList="oneYearkecheng.colorList"
              :legendList="oneYearkecheng.legendList"
              :colorName="1"
              :innerText="'单位:次'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :circleSize="80"
            ></discountChart>
          </div>
          <div class="chart_name">图15 近一年课程访问情况</div>
        </div>

        <div class="chart_box" style="margin-bottom: 190px">
          <h4 style="margin-left: 1.5em">6.2 课程访问量排名</h4>
          <div class="standards_content echartsHeight" style="height: 1000px">
            <tcolumnarChart
              isShowTextColor="true"
              isExportTextColor="true"
              :refId="'resourceLibraryChart'"
              :datas="oneYearkechengfagnwen.dataList"
              :transverseData="oneYearkechengfagnwen.transverseData"
              :colorList="oneYearkechengfagnwen.colorList"
              :colorName="1"
              :innerText="'单位：次'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :circleSize="80"
            ></tcolumnarChart>
          </div>
          <div class="chart_name">图16 课程访问量排名（前十名）</div>
        </div>
      </div>
      <div>
        <div class="chart_box" style="margin-top: 100px">
          <h4 style="margin-left: 1.5em">6.3 课程活跃用户数排名</h4>
          <div class="standards_content echartsHeight" style="height: 1000px">
            <tcolumnarChart
              isShowTextColor="true"
              isExportTextColor="true"
              :refId="'resourceLibraryChart'"
              :datas="kechengActiveTop.dataList"
              :colorList="kechengActiveTop.colorList"
              :transverseData="kechengActiveTop.transverseData"
              :colorName="1"
              :innerText="'单位：人'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :circleSize="80"
            ></tcolumnarChart>
          </div>
          <div class="chart_name">图17 课程活跃用户数排名（前十名）</div>
        </div>
      </div>
      <el-backtop></el-backtop>
    </div>
  </div>
</template>

<script>
import circularChart from "@/components/chart/circularChart.vue"; // 引入圆形图表
import vcolumnarChart from "@/components/chart/vcolumnarChart.vue"; // 引入竖柱状图图表
import tcolumnarChart from "@/components/chart/tcolumnarChart.vue"; // 引入横柱图图表
import discountChart from "@/components/chart/discountChart.vue"; // 引入折线图图表
import waterDropChart from "@/components/chart/waterDropChart.vue"; // 引入水滴图图表
import distributionChart from "@/components/chart/distributionChart.vue";
// 地图
export default {
  components: {
    circularChart,
    vcolumnarChart,
    tcolumnarChart,
    discountChart,
    waterDropChart,
    distributionChart,
  },
  data() {
    return {
      completeNum: 0,
      year: "",
      yearAndMonthly: "",
      yearMonthText: "",
      colorList: [
        "#3B85FB",
        "#FD398E",
        "#8B68F1",
        "#EE6F5E",
        "#E0D35F",
        "#5470C6",
        "#DE7E4B",
        "#DE524B",
      ], // 柱状图或折线图的颜色
      colorList1: [
        "#ff70a3",
        "#ededed",
        "#d88bff",
        "#95ec69",
        "#8f8f8f",
        "#cdcdcd",
        "#AD8E4B",
        "#CA524B",
      ],

      header: {
        allHostUnit: "",
        coHostUnit: [],
        endTime: "",
        hostUnit: "",
        startTime: "",
        status: "",
        zykName: "",
        zykNum: "",
      },
      endTime: "",
      startTime: "",

      resourceLibrary: {
        // 图1 资源库注册用户类型分布总体情况
        dataList: [],
        total: 0,
        FristYear: "",
        SecondYear: "",
        ThirdYear: "",
        FourthYear: "",
        // FifthYear: '',
        FristNum: 0,
        SecondNum: 0,
        ThirdNum: 0,
        FourthNum: 0,
        // FifthNum: 0,
        // teacherNum: 0,
        // studenNum: 0,
        delNum: 0,
      },
      shengfenperson: {
        dataList: [],
        colorList: [],
      },
      register: {
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
      },
      ziyuan: {
        dataList: [],
        other: 0,
        total: 0,
        teacher: 0,
        totalProvince: 0,
        student: 0,
        studentList: 0,
        teacherList: 0,
        social: 0,
        enterprise: 0,
        totalSchool: 0,
      },
      ziyuantu: {
        dataList: [],
        transverseData: [],
        colorList: [],
      },
      UserCreateList: {
        // 图2 新用户注册情况分布
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
      },

      projectTop: {
        // 图三 参加单位注册用户数排名
        dataList: [],
        colorList: [],
        transverseData: [],
      },

      sucaiziyuanAll: {
        total: 0,
        WenbenBai: 0,
        web: 0,
        dataList: [],
        textVo: {
          sumValue: 0,
          percentage: 0,
        },
        textPPTVo: {
          sumValue: 0,
          percentage: 0,
        },
        animationVo: {
          sumValue: 0,
          percentage: 0,
        },
        virtualVo: {
          sumValue: 0,
          percentage: 0,
        },
        audioVo: {
          sumValue: 0,
          percentage: 0,
        },
        videoVo: {
          sumValue: 0,
          percentage: 0,
        },
        smallCourseVo: {
          sumValue: 0,
          percentage: 0,
        },
        otherVo: {
          sumValue: 0,
          percentage: 0,
        },
        originVo: {
          sumValue: 19016,
          percentage: 0,
        },
        noActiveResourceCountVo: {
          sumValue: 177,
          percentage: 0,
        },
        courseResourceVo: {
          sumValue: 0,
          percentage: 0,
        },
        questionVo: {
          sumValue: 0,
          percentage: 0,
        },
        resourceLogCount: 0,
        viewResourceVo: {
          sumValue: 0,
          percentage: 0,
        },
        commentResourceVo: {
          sumValue: 0,
          percentage: 0,
        },
        downloadResourceVo: {
          sumValue: 0,
          percentage: 0,
        },
        collectionResourceVo: {
          sumValue: 0,
          percentage: 0,
        },
        otherResourceVo: {
          sumValue: 0,
          percentage: 0,
        },
        averageResourceLogCount: 46,
      },
      sucaiyearAdd: {
        FristYear: "",
        SecondYear: "",
        ThirdYear: "",
        FourthYear: "",
        FifthYear: "",
        FristNum: 0,
        SecondNum: 0,
        ThirdNum: 0,
        FourthNum: 0,
        FifthNum: 0,
        delNum: 0,
      },
      sucaiziyuanCreated: {
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
      },
      SucaiziyuanCreated: {
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
      },
      kechengAll: {
        count: 0,
      },
      kechengcreateds: {
        dataList: [],
        colorList: [],
        transverseData: [],
      },
      useractiveAllList: {
        total: 0,
        dataList: [],
        colorList: [],
        transverseData: [],
        ziyuansucai: 0,
        luntan: 0,
        zuoye: 0,
        kaoshi: 0,
        sucaiAvg: 0,
      },
      userTotal: {
        total: 0,
        studentAvg: 0,
        actionUser: 0,
      },
      differentUserTime: {
        dataList: [],
        colorList: [],
        transverseData: [],
        legendList: [],
      },
      userxingwei: {
        dataList: [],
        colorList: [],
      },
      sucaiziyuanyingyong: {
        dataList: [],
        colorList: [],
        transverseData: [],
        legendList: [],
      },
      sucaiziyuanfagnwen: {
        dataList: [],
        colorList: [],
        transverseData: [],
      },
      oneYearkecheng: {
        dataList: [],
        colorList: [],
        transverseData: [],
      },
      oneYearkechengfagnwen: {
        dataList: [],
        colorList: [],
        transverseData: [],
      },
      typeDistribution: {
        // 图2  当前资源库资源、课程情况
        dataList: [],
        transverseData: [],
        spNumber: 0,
        dhNumber: 0,
        txtxNumber: 0,
        xnfzNumber: 0,
        wbNumber: 0,
        wkNumber: 0,
        ypNumber: 0,
        kjNumber: 0,
        pptNumber: 0,
        fmtNumber: 0,
        qtNumber: 0,
        total: 0,
      },

      waterDrop: {
        teacher: 0, // 图6 资源库无活动数据情况
        student: 0, // 图6 资源库无活动数据情况
        resource: 0, // 图6 资源库无活动数据情况
        lastresource: 0, // 图11 资源库无访问资源较上月变化情况
        majorteacher: 0, // 图8 主持院校与参建院校新增占比情况
        majorstudent: 0, // 图8 主持院校与参建院校新增占比情况
        unitteacher: 0, // 图8 主持院校与参建院校新增占比情况
        unitstudent: 0, // 图8 主持院校与参建院校新增占比情况
        teacherNum: 0,
        studentNum: 0,
        resourceNum: 0,
        lastresourceNum: 0,
        majorteacherNum: 0,
        majorstudentNum: 0,
        unitteacherNum: 0,
        unitstudentNum: 0,
      },

      majorUser: {
        // 图8 主持院校与参建院校新增占比情况
        teacher: 0,
        student: 0,
        cjteacher: 0,
        cjstudent: 0,
      },
      kechengActiveTop: {
        dataList: [],
        colorList: [],
        transverseData: [],
      },
      tearchTopList: {
        dataList: [],
        colorList: [],
        transverseData: [],
      },
      studentTopList: {
        dataList: [],
        colorList: [],
        transverseData: [],
      },
      sss: {
        total: 0,
        dataList: [],
        colorList: [],
        transverseData: [],
        ziyuansucai: 0,
        luntan: 0,
        zuoye: 0,
        kaoshi: 0,
        sucaiAvg: 0,
      },
      update: {
        FristYear: [],
        SecondYear: [],
        ThirdYear: [],
      },
      totalNum: 0,
      loading: "", // 是否导出加载中
      timeDate: "",
    };
  },
  created() {
    console.log(111111111);
    if (this.$route.query) {
      const { token } = this.$route.query;
      this.timeDate = this.$route.query.endDate || "";
      sessionStorage.setItem("lrmv2token", token);
      const { zykid } = this.$route.query;
      this.dataChange(zykid);
      this.$route.query.zykName = decodeURIComponent(this.$route.query.zykName);
    }

    this.getas();

    this.resourceLibraryDom();
    // 图1
    // 当前资源库用户情况
    this.getUserCount();
    // 删除用户数
    this.del();
    //  图 1-2
    // this.UserCreateLists();
    this.shengfenPer();
    this.getUserRegisterTime();
    // 图 1-3
    this.projectTopLists();
    // 图2-1

    this.sucaiziyuanAlls(); //  素材资源总览

    this.sucaiziyuanadd();
    this.sucaidel();
    // this.sucaiziyuanCreateds();
    // this.SucaiziyuanCreateds();
    // 图3-1
    this.kechenAlls();
    this.kechengcreated();

    // 图片 4-3
    this.UserTime();
    this.userTOtals();
    this.Userxingweis();

    this.useractiveTime(); // 用户行为类型分布

    // this.useractiveTime()    // 用户行为类型分布
    setTimeout(() => {
      this.useractiveAll();
    }, 1500);

    // 图 5-1
    this.sucaiziyuanyingyongs();

    this.sucaiziyuanfagnwens();

    // 6-1 近一年课程资源访问情况
    this.oneYearkechengs();
    // 6-2 课程访问量排名
    this.oneYearkechengfagnwens();
    // 6-3  课程活跃用户量排名
    this.kechengActiveTops();

    // 7-1 教师访问排名
    this.tearchTop();
    // 7-2 学生访问排名
    this.studentTop();

    // this.getas();
  },
  methods: {
    dataChange(e) {
      this.$axios
        .post(this.$apiurls.major_switch, e, {
          loading: false,
        })
        .then((res) => {
          if (res.data) {
            sessionStorage.setItem("zykId", e);
            this.reload();
          }
        });
    },

    reload() {
      // 切换专业刷新视图层
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    // 导出月报
    toImage() {
      this.loading = this.$loading({
        lock: true,
        text: "正在导出中，请稍后...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      this.$axios
        .post(
          this.$apiurls.report_yaer_getZykInformationVo,
          {
            courseName: "",
            isAll: false,
            month: this.yearAndMonthly,
            reportType: 0,
            zykId: sessionStorage.getItem("zykId"),
            zykName: this.header.zykName,
            zykNum: this.header.zykNum,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            window.open(res.data);
            this.loading.close();
          }
        })
        .catch(() => {
          this.loading.close();
        });
    },

    getas() {
      this.$axios
        .post(this.$apiurls.report_yaer_getZykInformationVo, {
          loading: false,
        })
        .then((res) => {
          this.header = res.data;
          // this.endTime = res.data.endTime.slice(0, 7)
          // this.startTime = res.data.startTime.slice(0, 7)
          this.yearMonthText = `${res.data.allHostUnit.replaceAll(",", "，")}`;
          // this.yearMonthText = "山西省财政税务专科学校，山东商业职业技术学院，山东商业职业技术学院";
          this.completeNum = this.completeNum + 1;
          this.UserCreateLists();
          this.SucaiziyuanCreateds();
          this.sucaiziyuanCreateds();
        });
    },
    // 用户总览 - 历年用户新增资源 (头部报文)
    resourceLibraryDom() {
      this.$axios
        .post(`${this.$apiurls.report_yaer_getResourceOrUserUpdateVo}?statType=1`, {
          loading: false,
        })
        .then((res) => {
          let total = 0;
          const arrList = [];
          const transverse = [];
          for (let i = 0; i <= res.data.length - 1; i++) {
            total += parseFloat(res.data[i].num);
            arrList.push(res.data[i].num);
            transverse.push(res.data[i].yearUpdate);
          }

          this.resourceLibrary.total = total;
          // 年份
          this.resourceLibrary.FristYear = transverse[0];
          this.resourceLibrary.SecondYear = transverse[1];
          this.resourceLibrary.ThirdYear = transverse[2];
          this.resourceLibrary.FourthYear = transverse[3];

          // 数量
          this.resourceLibrary.FristNum = arrList[0];
          this.resourceLibrary.SecondNum = arrList[1];
          this.resourceLibrary.ThirdNum = arrList[2];
          this.resourceLibrary.FourthNum = arrList[3];
        });
    },

    // 用户总览 - 删除用户数 (头部报文)
    del() {
      this.$axios
        .post(this.$apiurls.report_yaer_getDeleteNum, 1, {
          loading: false,
        })
        .then((res) => {
          this.resourceLibrary.delNum = res.data;
        });
    },

    // 图1-1  用户总览头部报文
    getUserCount() {
      this.$axios
        .post(this.$apiurls.ReportFile_getBriefUserCount, {
          loading: false,
        })
        .then((res) => {
          const arrList = [];
          arrList.push(
            {
              name: "学生",
              value: res.data.student,
            },
            {
              name: "教师",
              value: res.data.teacher,
            }
          );
          this.ziyuan = res.data;
          this.ziyuan.teacherList = parseFloat(
            ((this.ziyuan.teacher / this.ziyuan.total) * 100).toFixed(2)
          );
          this.ziyuan.studentList = parseFloat(
            ((this.ziyuan.student / this.ziyuan.total) * 100).toFixed(2)
          );
          this.ziyuan.dataList = arrList;
          this.completeNum = this.completeNum + 1;
        });
    },
    // 图2-1  省份人数
    shengfenPer() {
      this.$axios
        .post(this.$apiurls.Lv2ReportFile_getBriefProvinceDistribution, 1, {
          loading: false,
        })
        .then((res) => {
          this.shengfenperson.dataList = res.data;
          this.shengfenperson.colorList = this.colorList;
          this.completeNum = this.completeNum + 1;
        });
    },
    //  1-2   资源库用户注册时间分布
    getUserRegisterTime() {
      this.$axios
        .post(`${this.$apiurls.report_yaer_getResourceOrUserUpdateVo}?statType=1`, {
          loading: false,
        })
        .then((res) => {
          const arrList = [];
          const transverse = [];
          for (let i = 0; i <= res.data.length - 1; i++) {
            arrList.push(res.data[i].num);
            transverse.push(res.data[i].yearUpdate.substring(0, 5));
          }
          this.register.dataList = arrList;
          this.register.transverseData = transverse;
          this.register.colorList = this.colorList;
          this.register.legendList = ["年用户注册数"];
          this.completeNum = this.completeNum + 1;
        });
    },
    // 图1-2  新用户注册情况分布
    UserCreateLists() {
      this.$axios
        .post(
          `${
            this.$apiurls.ReportFile_getBriefUserNew
          }?type=1&startTime=${this.header.startTime.slice(
            0,
            7
          )}&endTime=${this.header.endTime.slice(0, 7)}`,
          {
            loading: false,
          }
        )
        .then((res) => {
          const transverse = [];
          for (let i = 0; i <= res.data.name.length - 1; i++) {
            transverse.push(res.data.name[i]);
          }
          this.UserCreateList.dataList = res.data.value;
          this.UserCreateList.colorList = this.colorList;
          this.UserCreateList.transverseData = transverse;
          this.UserCreateList.legendList = ["年用户注册数"];
          this.completeNum = this.completeNum + 1;
        });
    },

    // 图1-3  单位参建排名
    projectTopLists() {
      this.$axios
        .post(this.$apiurls.ReportFile_getBriefSchoolUserHot, 1, {
          loading: false,
        })
        .then((res) => {
          // let arrList = [];
          // let transverse = [];
          // let objs = {"name":["江苏旅游职业学院","无锡商业职业技术学院","常州旅游商贸高等职业技术学校","顺德职业技术学院","扬州中瑞酒店职业学院","江苏省滨海中等专业学校","扬州生活科技学校","新疆伊犁丝路职业学院","江海职业技术学院","江苏省扬州旅游商贸学校"],
          //   "value":[13811,506,89,67,50,46,43,33,21,12],"separateContent":[]}
          // console.log(objs)
          // if (res) {
          //   for (let i = 0; i <= objs.name.length - 1; i++) {
          //     arrList.push(objs.value[i]);
          //     transverse.push(objs.name[i]);
          //   }
          // }
          //
          // this.projectTop.dataList = arrList;
          // this.projectTop.transverseData = transverse;
          // this.projectTop.colorList = this.colorList;
          const arrList = [];
          const transverse = [];
          if (res) {
            for (let i = 0; i <= res.data.name.length - 1; i++) {
              arrList.push(res.data.value[i]);
              transverse.push(res.data.name[i]);
            }
          }
          this.projectTop.dataList = arrList;
          this.projectTop.transverseData = transverse;
          this.projectTop.colorList = this.colorList;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 图2-1 (用户建设与更新情况) 素材资源总览占比部分报文
    sucaiziyuanAlls() {
      this.$axios
        .post(this.$apiurls.report_year_getBasicReportResourceVo, {
          loading: false,
        })
        .then((res) => {
          const arrList = [];
          arrList.push(
            {
              name: "文本类/图形图像",
              value: res.data.textVo.sumValue,
            },
            {
              name: "文本型演示文稿(ppt、网页课件与富媒体等)",
              value: res.data.textPPTVo.sumValue,
            },
            {
              name: "动画类",
              value: res.data.animationVo.sumValue,
            },
            {
              name: "虚拟仿真类",
              value: res.data.virtualVo.sumValue,
            },
            {
              name: "音频类",
              value: res.data.audioVo.sumValue,
            },
            {
              name: "视频类",
              value: res.data.videoVo.sumValue,
            },
            {
              name: "微课类",
              value: res.data.smallCourseVo.sumValue,
            },
            {
              name: "其他类",
              value: res.data.otherVo.sumValue,
            }
          );
          this.sucaiziyuanAll.dataList = arrList;
          this.sucaiziyuanAll.textVo = res.data.textVo;
          this.sucaiziyuanAll.textPPTVo = res.data.textPPTVo;
          this.sucaiziyuanAll.animationVo = res.data.animationVo;
          this.sucaiziyuanAll.virtualVo = res.data.virtualVo;
          this.sucaiziyuanAll.audioVo = res.data.audioVo;
          this.sucaiziyuanAll.videoVo = res.data.videoVo;
          this.sucaiziyuanAll.smallCourseVo = res.data.smallCourseVo;
          this.sucaiziyuanAll.otherVo = res.data.otherVo;
          this.sucaiziyuanAll.originVo = res.data.originVo;
          this.sucaiziyuanAll.noActiveResourceCountVo = res.data.noActiveResourceCountVo;
          this.sucaiziyuanAll.courseResourceVo = res.data.courseResourceVo;
          this.sucaiziyuanAll.questionVo = res.data.questionVo;
          this.sucaiziyuanAll.viewResourceVo = res.data.viewResourceVo;
          this.sucaiziyuanAll.commentResourceVo = res.data.commentResourceVo;
          this.sucaiziyuanAll.downloadResourceVo = res.data.downloadResourceVo;
          this.sucaiziyuanAll.collectionResourceVo = res.data.collectionResourceVo;
          this.sucaiziyuanAll.otherResourceVo = res.data.otherResourceVo;
          this.sucaiziyuanAll.total = res.data.resourceCount;
          this.sucaiziyuanAll.textPPTVo.percentage = `${(
            parseFloat(this.sucaiziyuanAll.textPPTVo.percentage) +
            parseFloat(this.sucaiziyuanAll.textVo.percentage)
          ).toFixed(2)}%`;
          this.sucaiziyuanAll.WenbenBai = res.data.textVo.percentage;

          this.sucaiziyuanAll.web = `${(
            (res.data.textPPTVo.sumValue / res.data.resourceCount) *
            100
          ).toFixed(2)}%`;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 图 2-1 (用户建设与更新情况) 素材年份用户增长部分报文
    sucaiziyuanadd() {
      this.$axios
        .post(`${this.$apiurls.report_yaer_getResourceOrUserUpdateVo}?statType=2`, {
          loading: false,
        })
        .then((res) => {
          console.log(res, 1111111111);
          this.update.FristYear = res.data[0];
          this.update.SecondYear = res.data[1];
          this.update.ThirdYear = res.data[2];
          this.completeNum = this.completeNum + 1;
        });
    },

    // 图 2-1 (用户建设与更新情况) 素材年份用户删除部分报文
    sucaidel() {
      this.$axios
        .post(this.$apiurls.report_yaer_getDeleteNum, 2, {
          loading: false,
        })
        .then((res) => {
          this.sucaiyearAdd.delNum = res.data;
          this.completeNum = this.completeNum + 1;
        });
    },
    // 素材资源创建时间分布柱型图
    sucaiziyuanCreateds() {
      this.$axios
        .post(`${this.$apiurls.report_yaer_getResourceOrUserUpdateVo}?statType=3`, {
          loading: false,
        })
        .then((res) => {
          console.log(res, "SucaiziyuanCreateds");
          const arrList = [];
          const transverse = [];
          for (let i = 0; i <= res.data.length - 1; i++) {
            arrList.push(res.data[i].num);
            transverse.push(res.data[i].yearUpdate.substring(0, 5));
          }
          this.sucaiziyuanCreated.dataList = arrList;
          this.sucaiziyuanCreated.transverseData = transverse;
          this.sucaiziyuanCreated.colorList = this.colorList;
          this.sucaiziyuanCreated.legendList = ["年资源新增"];
          this.completeNum = this.completeNum + 1;
        });
    },
    // 素材资源创建时间分布折线图

    SucaiziyuanCreateds() {
      this.$axios
        .post(
          `${
            this.$apiurls.ReportFile_getBriefUserNew
          }?type=2&startTime=${this.header.startTime.slice(
            0,
            7
          )}&endTime=${this.header.endTime.slice(0, 7)}`,
          {
            loading: false,
          }
        )
        .then((res) => {
          this.SucaiziyuanCreated.dataList = res.data.value;
          this.SucaiziyuanCreated.transverseData = res.data.name;
          this.SucaiziyuanCreated.colorList = this.colorList;
          this.SucaiziyuanCreated.legendList = ["月资源创建数"];
          this.completeNum = this.completeNum + 1;
        });
    },
    // 图 3-1 (课程建设与更新情况)  课程总览
    kechenAlls() {
      this.$axios
        .post(this.$apiurls.report_year_getCourseCountVo, {
          loading: false,
        })
        .then((res) => {
          this.kechengAll.count = res.data.courseBzNum;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 图 3-2  课程创建时间分布
    kechengcreated() {
      this.$axios
        .post(this.$apiurls.Lv2ReportFile_getBriefUserByYear, {
          loading: false,
        })
        .then((res) => {
          const transverse = [];
          for (let i = 0; i <= res.data.name.length - 1; i++) {
            transverse.push(`${res.data.name[i]}年`);
          }
          this.kechengcreateds.dataList = res.data.value;
          this.kechengcreateds.transverseData = transverse;
          this.kechengcreateds.colorList = this.colorList;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 用户行为总览
    useractiveAll() {
      this.$axios
        .post(this.$apiurls.report_year_getResourceApplicationVo, 2, {
          loading: false,
        })
        .then((res) => {
          const arrList = [];
          this.useractiveAllList.total = res.data[0].num;
          this.useractiveAllList.sucai = res.data[2].num;
          this.useractiveAllList.luntan = res.data[3].num;
          this.useractiveAllList.zuoye = res.data[4].num;
          this.useractiveAllList.kaoshi = res.data[5].num;
          this.useractiveAllList.sucaiAvg = (
            this.useractiveAllList.sucai / this.sucaiziyuanAll.total
          ).toFixed(2);

          arrList.push(
            {
              name: res.data[1].action,
              value: res.data[1].num,
            },
            {
              name: res.data[2].action,
              value: res.data[2].num,
            },
            {
              name: res.data[3].action,
              value: res.data[3].num,
            },
            {
              name: res.data[4].action,
              value: res.data[4].num,
            },
            {
              name: res.data[5].action,
              value: res.data[5].num,
            },
            {
              name: res.data[6].action,
              value: res.data[6].num,
            }
          );

          this.useractiveAllList.dataList = arrList;
          this.completeNum = this.completeNum + 1;
        });
    },
    // 用户行为类型分布 (2021用户行为总量头部报文)
    userTOtals() {
      this.$axios
        .post(
          `${this.$apiurls.Lv2ReportFile_getBriefUserActionTotal}?year=${this.timeDate.substring(
            0,
            4
          )}`
        )
        .then((res) => {
          this.userTotal = res.data;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 图 4-1 用户行为类型分布   (近一年不同类型用户行为时间分布情况(按照天统计)  (单位:次)

    useractiveTime() {
      this.$axios
        .post(this.$apiurls.Lv2ReportFile_getBriefUserByDayDistribution, {
          loading: false,
        })
        .then((res) => {
          // console.log()
          let total = 0;
          for (let i = 0; i <= res.data.value.length - 1; i++) {
            total += parseFloat(res.data.value[i]);
          }
          this.sss.total = total;
          this.sss.dataList = res.data.value;
          this.sss.transverseData = res.data.name;
          this.sss.colorList = this.colorList;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 图 4-2 不同类型用户行为分布
    Userxingweis() {
      this.$axios
        .post(this.$apiurls.applicationReport_getBriefUserByTypeDistribution, {
          loading: false,
        })
        .then((res) => {
          const arrList = [];
          arrList.push(
            {
              name: res.data[0].name,
              value: res.data[0].value,
            },
            {
              name: res.data[1].name,
              value: res.data[1].value,
            },
            {
              name: res.data[2].name,
              value: res.data[2].value,
            },
            {
              name: res.data[3].name,
              value: res.data[3].value,
            }
          );
          this.userxingwei.dataList = arrList;
          this.completeNum = this.completeNum + 1;
        });
    },

    //  图 4-3 近一年不同类型用户行为时间分布情况
    UserTime() {
      this.$axios
        .post(this.$apiurls.ReportFile_getBriefUserByTypeDayDistribution, {
          loading: false,
        })
        .then((res) => {
          this.differentUserTime.dataList = res.data.dataList;
          this.differentUserTime.transverseData = res.data.transverseData;
          this.differentUserTime.legendList = res.data.legendList;
          this.differentUserTime.colorList = this.colorList;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 图5-1 近一年素材资源访问情况
    sucaiziyuanyingyongs() {
      this.$axios
        .post(this.$apiurls.overallPortrait_getResourceCountByType, 30, {
          loading: false,
        })
        .then((res) => {
          this.sucaiziyuanyingyong.dataList = res.data.dataList;
          this.sucaiziyuanyingyong.transverseData = res.data.transverseData;
          this.sucaiziyuanyingyong.legendList = res.data.legendList;
          this.sucaiziyuanyingyong.colorList = this.colorList;
          this.sucaiziyuanyingyong.legendList = ["访问量"];
          this.completeNum = this.completeNum + 1;
        });
    },
    entityToString(fcString) {
      const divs = document.createElement("div");
      divs.innerHTML = fcString;
      const res = divs.innerText || divs.textContent;
      return res;
    },
    // 图5-2 素材资源访问量排名
    sucaiziyuanfagnwens() {
      this.$axios
        .post(this.$apiurls.Lv2ReportFile_getBriefHotResource, 26, {
          loading: false,
        })
        .then((res) => {
          this.sucaiziyuanfagnwen.dataList = res.data.value;
          this.sucaiziyuanfagnwen.transverseData = res.data.name.map((item) =>
            this.entityToString(item)
          );
          this.sucaiziyuanfagnwen.colorList = this.colorList;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 图 6-1 近一年课程资源访问情况
    oneYearkechengs() {
      this.$axios
        .post(
          this.$apiurls.curriculumPortrait_getCourseMonthlyActionCountEchart,
          { limitNum: 10, statType: 43 },
          {
            loading: false,
          }
        )
        .then((res) => {
          const arr = [];
          for (let i = 0; i <= res.data.length - 1; i++) {
            arr.push(res.data[i].value);
          }
          this.oneYearkecheng.dataList = arr;
          this.oneYearkecheng.colorList = this.colorList;
          this.oneYearkecheng.transverseData = res.data[0].name;
          this.oneYearkecheng.legendList = ["标准化课程", "个性化课程"];
          this.completeNum = this.completeNum + 1;
        });
    },

    // 6-2  课程访问量排名
    oneYearkechengfagnwens() {
      this.$axios
        .post(this.$apiurls.Lv2ReportFile_getBriefHotResource, 25, {
          loading: false,
        })
        .then((res) => {
          this.oneYearkechengfagnwen.dataList = res.data.value;
          this.oneYearkechengfagnwen.transverseData = res.data.name;
          this.oneYearkechengfagnwen.colorList = this.colorList;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 6-3  课程活跃用户量排名
    kechengActiveTops() {
      this.$axios
        .post(this.$apiurls.Lv2ReportFile_getBriefHotResource, 38, {
          loading: false,
        })
        .then((res) => {
          this.kechengActiveTop.dataList = res.data.value;
          this.kechengActiveTop.transverseData = res.data.name;
          this.kechengActiveTop.colorList = this.colorList;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 7-1  教师访问量排名
    tearchTop() {
      this.$axios
        .post(this.$apiurls.Lv2ReportFile_getBriefHotResource, 6, {
          loading: false,
        })
        .then((res) => {
          this.tearchTopList.dataList = res.data.value;
          this.tearchTopList.transverseData = res.data.name;
          this.tearchTopList.colorList = this.colorList;
          this.completeNum = this.completeNum + 1;
        });
    },

    studentTop() {
      this.$axios
        .post(this.$apiurls.Lv2ReportFile_getBriefHotResource, 11, {
          loading: false,
        })
        .then((res) => {
          this.studentTopList.dataList = res.data.value;
          this.studentTopList.transverseData = res.data.name;
          this.studentTopList.colorList = this.colorList;
          this.completeNum = this.completeNum + 1;
        });
    },

    dataHandler(data) {
      return data > 100000000
        ? `${(data / 100000000).toFixed(2)}亿`
        : data > 10000
        ? `${(data / 10000).toFixed(2)}万`
        : data;
    },
    // // 进度条上的百分比值转化
    // teacherFormat() {
    //   return `${this.waterDrop.teacherNum}%`;
    // },
    // studentFormat() {
    //   return `${this.waterDrop.studentNum}%`;
    // },
    // resourceFormat() {
    //   return `${this.waterDrop.resourceNum}%`;
    // },
    // lastresourceFormat() {
    //   return `${this.waterDrop.lastresourceNum}%`;
    // },
    // majorteacherFormat() {
    //   return `${this.waterDrop.majorteacherNum}%`;
    // },
    // majorstudentFormat() {
    //   return `${this.waterDrop.majorstudentNum}%`;
    // },
    // unitteacherFormat() {
    //   return `${this.waterDrop.unitteacherNum}%`;
    // },
    // unitstudentFormat() {
    //   return `${this.waterDrop.unitstudentNum}%`;
    // },
  },
};
</script>

<style scoped>
.analysisReport {
  width: 100%;
  height: 27320px;
  /* height: 63020px; */
  background: #fff;
}

h1,
h2,
h3,
h4,
h5,
p {
  margin: 0px;
  padding: 0px;
}

.analysisReport_box {
  /*width: 70%;*/
  width: 85%;
  margin: 0px auto;
  /* height: 14500px; */
}

.header_titles {
  display: flex;
  justify-content: center;
  flex-flow: column;
  color: #000;
  text-align: center;
  position: relative;
  font-size: 40px;
}

.header_titles h1 {
  font-size: 60px;
  font-weight: bold;
  color: #1d244e;
  line-height: 70px;
}

.header_titles .monthly {
  font-size: 40px;
  font-weight: 400;
  color: #1d244e;
  line-height: 30px;
  margin-top: 6px;
}

.number_time {
  margin: 1.25rem 0rem;
}

.number_time div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #707f9d;
  font-size: 1.5625rem;
}

.number_time p {
  width: 100%;
  height: 0.0625rem;
  background: #707f9d;
  margin-top: 0.5rem;
}

.number_time p:last-child {
  opacity: 0.5;
  margin-top: 0.25rem;
}

.division {
  width: 100%;
  height: 40px;
  position: relative;
  clear: both;
  margin: 20px 0px;
}

.division span {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  background: #fff;
  font-weight: bold;
  font-size: 50px;
  color: #1d244e;
  padding: 0px 50px;
  line-height: 30px;
}

.chart_box {
  width: 100%;
  height: auto;
  margin-bottom: 60px;
  clear: both;
}

.chart_box,
.catalogue h3 {
  font-weight: 700;
  font-size: 50px;
  color: #1d244e;
  /*text-indent: 40px;*/
  line-height: 40px;
  margin-bottom: 15px;
  margin-top: 50px;
}

.chart_box h3 {
  font-size: 50px;
  margin-bottom: 35px;
}

.chart_box,
.catalogue h4 {
  font-weight: 700;
  font-size: 50px;
  color: #1d244e;
  /*text-indent: 40px;*/
  /* line-height: 40px; */
  margin-bottom: 15px;
  margin-top: 50px;
}

.chart_box h4 {
  font-size: 45px;
  margin-bottom: 35px;
}

.chart_box,
.catalogue h5 {
  font-weight: 700;
  font-size: 45px;
  color: #1d244e;
  /*text-indent: 40px;*/
  line-height: 40px;
  margin-bottom: 15px;
  margin-top: 50px;
}

.chart_box h5 {
  font-size: 40px;
  margin-bottom: 35px;
}

.chart_box h6 {
  font-weight: 700;
  font-size: 40px;
  color: #1d244e;
  /*text-indent: 40px;*/
  line-height: 40px;
  margin-bottom: 15px;
  margin-top: 50px;
}

.chart_box p {
  font-weight: 540 !important;
  font-size: 35px !important;
  text-indent: 2em;
  line-height: 70px;
  color: #272a3f !important;
}

.chart_box .echartsHeight,
.layout,
.speed {
  width: 80%;
  height: calc(100vw / 1080 * 300);
  height: 650px;
  margin: 10px auto 0px;
}

.speed {
  width: 100%;
  height: auto;
}

.speed > div {
  width: 80%;
  font-size: 25px;
  color: #707f9d;
  line-height: 28px;
  margin: 20px auto;
}

.speed .el-col {
  margin-bottom: 15px;
}

.speed .el-col div {
  height: 40px;
  display: flex;
  align-items: center;
}

.chart_box .chart_name {
  font-weight: 540 !important;
  text-align: center;
  font-size: 32px;
  color: #272a3f;
  clear: both;
}

.chart_box .notes {
  margin: 35px;
  line-height: 33px;
  font-size: 22px;
  color: #707f9d;
}

/* 布局 */
.layout {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.export {
  position: absolute;
  right: 10px;
  top: 10px;
}

.center {
  text-align: center;
}

.divorced {
  margin-top: 40px;
}

.biaoge {
  height: 750px;
  font-weight: 540 !important;
  width: 97%;
  margin: 0px auto 25px;
  /* font-size: 16px !important; */
  color: #272a3f !important;
}

.biaoge .twoTable {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.course {
  text-align: center;
  margin: 0px 10px;
}

.course tr {
  height: 45px;
  line-height: 45px;
  color: #707f9d;
  font-size: 26px;
}

.course tr:nth-child(2n) {
  background: rgba(11, 201, 212, 0.2);
  color: #566178;
}

.course tr:nth-child(2n-1) {
  background: rgba(73, 187, 233);

  color: #566178;
}

.course tr:first-child {
  background: rgb(88, 136, 248);
  color: #fff;
}

::v-deep .el-progress-bar__innerText {
  color: #000;
  font-size: 25px;
}

.HomePage {
  position: relative;
  padding-top: 20%;
  padding-left: 10%;
}

.HomePage #image {
  width: 700px;
  height: 150px;
  background: url("../../../../public/pdf.png") no-repeat;
  background-size: 100% 100%;
}

#PdfTitle {
  margin: 45% 0px 40% 0px;
  padding: 20px 0px 20px 40px;
  position: relative;
  border-left: 3px solid #729ac0;
}

#FristTitle {
  font-size: 50px;
  font-weight: 700;
  margin-bottom: 40px;
}

#SecondTitle {
  font-size: 65px;
  font-weight: 600;
  margin-bottom: 40px;
}

#ThrendTitle {
  font-size: 50px;
  font-weight: 600;
  margin-bottom: 40px;
}

#FourTitle {
  font-size: 55px;
  font-weight: 700;
  margin-bottom: 40px;
}

#foot {
  display: flex;
}

.HomePage .footBox {
  flex-direction: column;
  display: flex;
  align-items: center;
  font-size: 42px;
  margin-left: 4.5%;
}

.HomePage #foot p {
  margin: 20px 0px;
}

.catalogue {
  position: relative;
  padding: 10% 0px 0px 10%;
  margin-top: 300px;
}

/* 目录级别 */
.catalogue .title {
  text-align: center;
  margin-bottom: 4%;
  font-size: 40px;
}

.top {
  margin-top: 140px;
}
</style>
